export const TABLE_MODE_AGG_OPTIONS_METRIC = [
  { value: "", text: "None (column)" },
  { value: "SUM", text: "SUM" },
  { value: "AVG", text: "AVG" },
  { value: "COUNT", text: "COUNT" },
  { value: "MIN", text: "MIN" },
  { value: "MAX", text: "MAX" },
];

export const TABLE_MODE_AGG_OPTIONS_DATE = [
  { value: "", text: "None (column)" },
  { value: "YEAR", text: "Year" },
  { value: "QUARTER", text: "Quarter" },
  { value: "MONTH", text: "Month" },
  { value: "YYYYMM", text: "YYYYMM" },
];

export const TABLE_MODE_AGG_OPTION_COUNT_DISTINCT = {
  value: "COUNT_DISTINCT",
  text: "COUNT (distinct)",
};

export const TABLE_MODE_AGG_OPTIONS_DIMENSION = [
  { value: "", text: "—" },
  { value: "COUNT", text: "COUNT" },
  TABLE_MODE_AGG_OPTION_COUNT_DISTINCT,
];

export const TABLE_MODE_DISPLAY_TYPE_OPTIONS = [
  { value: "Dimension", text: "Dimension" },
  { value: "Metric", text: "Metric" },
  { value: "Date", text: "Date" },
  { value: "Identifier", text: "Identifier" },
];

export const TABLE_BAR_TYPE_OPTIONS = [
  { value: "Dimension", text: "Dimension" },
  { value: "Metric", text: "Metric" },
];

export const TABLE_BAR_GRAPH_OPTIONS = [
  { value: "no", text: "No" },
  { value: "yes", text: "Yes" },
];

export function appendCountDistinctOption(options) {
  if (
    !options.some(
      (o) => o.value === TABLE_MODE_AGG_OPTION_COUNT_DISTINCT.value,
    )
  ) {
    return [...options, TABLE_MODE_AGG_OPTION_COUNT_DISTINCT];
  }
  return options;
}
